/** Nepali locale for system-settings-ui. */
import type { SystemSettingsLocale } from './en'

export const systemSettingsNe = {
  systemSettings: {
    title: `प्रणाली सेटिङहरू`,
    tabs: {
      general: `सामान्य`,
      defaults: `पूर्वनिर्धारित`,
      recording: `कल रेकर्डिङ`,
    },
    common: {
      save: `परिवर्तनहरू सुरक्षित गर्नुहोस्`,
      active: `सक्रिय`,
      inactive: `निष्क्रिय`,
      yes: `हो`,
      no: `होइन`,
      loading: `लोड हुँदैछ...`,
      selectOption: `-- छान्नुहोस् --`,
      none: `कुनै पनि होइन`,
      unsavedChanges: `सुरक्षित नगरिएका परिवर्तनहरू`,
    },
    general: {
      title: `सामान्य`,
      defaultTimeZone: `पूर्वनिर्धारित समय क्षेत्र`,
      callParkTimeout: `कल पार्क समय सीमा (सेकेन्ड)`,
      callParkTimeoutHelp:
        'कल पार्क भएपछि फिर्ता हुनु अघि सेकेन्डमा समय। न्यूनतम ३० सेकेन्ड, अधिकतम १८०० सेकेन्ड। सिफारिस: ३००।',
      callParkWarning: `के तपाईं कल गर्नेहरूलाई {{minutes}} मिनेटको लागि पार्किङमा छोड्न निश्चित हुनुहुन्छ?`,
      extensionsTitle: `एक्सटेन्सनहरू`,
      extensionDigits: `एक्सटेन्सन अंकहरू`,
      enableIntercom: `इन्टरकम सक्षम गर्नुहोस्`,
      searchTimezone: 'समयक्षेत्र खोज्नुहोस्...',
      noTimezonesFound: 'कुनै समयक्षेत्र फेला परेन',
    },
    defaults: {
      voiceTitle: `भ्वाइस`,
      defaultAreaCode: `पूर्वनिर्धारित क्षेत्र कोड`,
      areaCodeRange: `क्षेत्र कोड २०० र ९९८ बीचमा हुनुपर्छ`,
      areaCodeDisallowed: `यो क्षेत्र कोड अनुमति छैन`,
      defaultCallerId: `पूर्वनिर्धारित कलर ID`,
      faxTitle: `फ्याक्स`,
      defaultFaxNumber: `पूर्वनिर्धारित फ्याक्स नम्बर`,
      defaultVirtualFax: `पूर्वनिर्धारित भर्चुअल फ्याक्स`,
      defaultVirtualFaxSearchPlaceholder: `भर्चुअल फ्याक्स एक्सटेन्सनहरू खोज्नुहोस्...`,
      defaultVirtualFaxSearchAriaLabel: `नाम वा नम्बरद्वारा भर्चुअल फ्याक्स एक्सटेन्सनहरू खोज्नुहोस्`,
      defaultVirtualFaxNoMatches: `त्यो खोजीसँग मेल खाने कुनै भर्चुअल फ्याक्स एक्सटेन्सन छैन।`,
      emergencyTitle: `आपतकालीन पूर्वनिर्धारित`,
      emergencyName: `आपतकालीन नाम`,
      emergencyNumber: `आपतकालीन नम्बर`,
      emergencyNumberHelp: `यो फिल्ड पढ्न-मात्र हो र यहाँ परिवर्तन गर्न सकिँदैन।`,
      emergencyAlert: `आपतकालीन चेतावनी`,
      holdMusicTitle: `होल्ड संगीत`,
      holdMusicPlaylist: `होल्ड संगीत`,
      noPlaylists: `कुनै प्लेलिस्ट उपलब्ध छैन`,
      playlistNotPlayableSuffix: `(कुनै अडियो ट्र्याक छैन)`,
      playlistEmptyError: `चयन गरिएको होल्ड संगीत प्लेलिस्टमा कुनै अडियो ट्र्याक छैन। ट्र्याकहरू थप्नुहोस् वा फरक प्लेलिस्ट छान्नुहोस्।`,
    },
    recording: {
      title: `कल रेकर्डिङ`,
      enableInbound: `आगमन कल रेकर्डिङ सक्षम गर्नुहोस्`,
      enableOutbound: `बहिर्गमन कल रेकर्डिङ सक्षम गर्नुहोस्`,
      enableInternal: `आन्तरिक कल रेकर्डिङ सक्षम गर्नुहोस्`,
    },
    toast: {
      saveSuccess: `सेटिङहरू सफलतापूर्वक सुरक्षित गरियो`,
      saveError: `सेटिङहरू सुरक्षित गर्न असफल भयो`,
      validationError: `सुरक्षित गर्न सकिँदैन — कृपया माथिका त्रुटिहरू सुधार्नुहोस्`,
    },
    error: {
      loadFailed: `प्रणाली सेटिङहरू लोड गर्न असफल भयो। कृपया पुन: प्रयास गर्नुहोस्।`,
    },
  },
} satisfies SystemSettingsLocale
